import { EditValuesForm } from "Components/Onboarding/BusinessEntity/Steps/BeneficialOwnersStep/OwnerModal/EditValuesForm";
import { ModalDialog } from "Components/Shared/Dialogs/ModalDialog";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  isOpen: boolean;
  publicID?: string;
  onClose: () => void;
};

const ModalResources = Resources.Onboarding.BusinessOnboarding.Steps.OwnerModal;

export const OwnerModal = ({ isOpen, publicID, onClose }: Props) => {
  const { t } = useResource();

  return (
    <ModalDialog
      isOpen={isOpen}
      onClose={onClose}
      title={t(ModalResources.Title)}
    >
      <EditValuesForm publicID={publicID} onAfterSubmit={onClose} />
    </ModalDialog>
  );
};
